module.exports = __webpack_public_path__ + "static/media/screenshot(16).0481ed9e.jpg";